import { define } from 'preactement';
import { ServiceCardDesktop } from './desktop/ServiceCardDesktop';
import { ServiceCardItem } from './general/ServiceCardItem';
import { ServiceCardMobile } from './mobile/ServiceCardMobile';

// ACHTUNG: Die Reihenfolge der Komponenten-Anmeldung spielt hier eine Rolle
define('sp-service-card-desktop', () => ServiceCardDesktop, { attributes: ['headline', 'card-type', 'link-more', 'highlighted'] });
define('sp-service-card-mobile', () => ServiceCardMobile, { attributes: ['headline', 'card-type', 'link-more', 'highlighted'] });
define('sp-service-card-item', () => ServiceCardItem, { attributes: ['href'] });
